<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CaK9ZU/tc-custom/9780253021472.jpg?1713383261884" alt="This image is the cover for the book Spirits of Crossbones Graveyard, New Anthropologies of Europe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spirits of Crossbones Graveyard, New Anthropologies of Europe
      </h1>
      <p class="bookDescription body article font2">
        <p>Every month, a ragtag group of Londoners gather in the site known as Crossbones Graveyard to commemorate the souls of medieval prostitutes believed to be buried there—the "Winchester Geese," women who were under the protection of the Church but denied Christian burial. In the Borough of Southwark, not far from Shakespeare's Globe, is a pilgrimage site for self-identified misfits, nonconformists, and contemporary sex workers who leave memorials to the outcast dead. Ceremonies combining raucous humor and eclectic spirituality are led by a local playwright, John Constable, also known as John Crow. His interpretation of the history of the site has struck a chord with many who feel alienated in present-day London. Sondra L. Hausner offers a nuanced ethnography of Crossbones that tacks between past and present to look at the historical practices of sex work, the relation of the Church to these professions, and their representation in the present. She draws on anthropological approaches to ritual and time to understand the forms of spiritual healing conveyed by the Crossbones rites. She shows that ritual is a way of creating the present by mobilizing the stories of the past for contemporary purposes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sondra L. Hausner
      </h2>
      
      <p class="authorDescription body article"><P>Sondra L. Hausner is Associate Professor in the Study of Religion, St. Peter's College, at the University of Oxford.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bda8e17e